import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-main-auxiliaire-medic',
  imports: [RouterOutlet],
  templateUrl: './main-auxiliaire-medic.component.html',
  styleUrl: './main-auxiliaire-medic.component.scss'
})
export class MainAuxiliaireMedicComponent {}
